import { formatAsDashedYearMonthDay } from "../../helpers/date-formatting-util.js";
import { widget } from "@foretagsplatsen/widgetjs";
import Timespan from "../../../models/period/Timespan.js";

/**
 * `datePickerWidget` is a simple widget used to pick a date.
 * It will popup a calendar to choose the date.
 * It also supports mobile devices.
 *
 * @param {{}} spec - Parameter object
 * @param {Date} spec.date       - Current date
 * @param {Date} spec.starDate   - Minimal date
 * @param {Date} spec.endDate    - Maximal date
 * @param {string} spec.cssClass - Extra css classes to attach to the input
 * @param {string} spec.name     - A "name" attribute to store in the input field
 * @param {object} my - protected fields holder
 * @return {*}
 */
function datePickerWidget(spec, my) {
	spec ||= {};
	my ||= {};
	const that = widget(spec, my);

	my.date = spec.date;
	my.cssClass = spec.cssClass || "";
	my.range = new Timespan();
	my.name = spec.name;

	that.onDateChanged = my.events.createEvent();

	that.getRange = function () {
		return my.range;
	};

	that.setRange = function (timespan) {
		my.range = timespan;
		that.update();
	};

	that.getSelectedDate = function () {
		return my.date || my.range.getEnd();
	};

	that.setSelectedDate = function (date) {
		my.date = date;
		that.update();
	};

	that.renderContentOn = function (html) {
		const input = html.input({
			"data-test": "date-picker",
			type: "date",
			class: ["date-picker", my.cssClass],
			min: my.formatDate(my.range.getStart()),
			max: my.formatDate(my.range.getEnd()),
			value: my.formatDate(my.date),
			name: my.name,
			// Workaround for browsers not supporting the date
			// input
			// (https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date#Handling_browser_support)
			pattern: "[0-9]{4}-[0-9]{2}-[0-9]{2}",
		});

		input.on("change", (event) => {
			my.date = event.target.valueAsDate;
			that.onDateChanged.trigger(my.date);
		});
	};

	my.formatDate = function (aDate) {
		if (!aDate) {
			// if no date, then do not set a limit, instead of fixing it to today
			return undefined;
		}

		return formatAsDashedYearMonthDay(aDate);
	};

	return that;
}

export default datePickerWidget;
